import "reflect-metadata";
/* eslint-disable no-console */
export default async function () {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    // const version = require('../../package.json').version
    console.log(`Infinite Objects UI Components`);
}
//# sourceMappingURL=init.js.map
